export default "__VITE_ASSET__DkBwwrzQ__"